module.exports = __webpack_public_path__ + "static/media/ParthJardosh_Resume.92c5926a.pdf";